// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Box, Dialog, DialogContent, DialogTitle, Fab, Grid, IconButton, Stack, Typography, } from '@mui/material';

// TODO: Import MUI icon
import { Close, MusicNote, YouTube } from '@mui/icons-material';

// TODO: Import context
import { Context } from '../Common/Context';
import { Text } from '../Common/Text';

// TODO: Import custom component
import { ContentTitle, } from '../Common/TypographyTYH';
import BoxImage from '../Common/BoxImage';
import StackImage from '../Common/StackImage';

const Activities = ({ onClick }) => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component Activities Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define variable
    const coverages = [
        { ID: 'MUSIC20260521_1', Title: '2025上學期音樂活動' },
        { ID: '20260511', Title: '到訪將軍澳宣道會宣基小學' },
        { ID: 'MUSIC20260521_2', Title: '喜樂音樂會2' },
        { ID: 'MUSIC20260521_3', Title: '管樂團訓練營' },
        { ID: '20260508', Title: '靈實地區長者服務樂韻組到訪本校' },
    ];
    const [openDialog, setOpenDialog] = React.useState(false);
    const [selectedId, setSelectedId] = React.useState(null);

    // TODO: Define event
    const handleClicked = (id) => {
        setSelectedId(id);
        setOpenDialog(true);
    };

    const handleDialogClose = () => {
        setOpenDialog(false);
        setSelectedId(null);
    };

    // TODO: Return component
    const RenderStackImage = ({ coverage }) => (
        <StackImage onClick={() => { handleClicked(coverage.ID) }} hover={true}>
            <Box
                component="img"
                src={`https://www.pohtyh.edu.hk/Files/Album/${coverage.ID}/Slide.jpg`}
                sx={{
                    aspectRatio: '16/9',
                    objectFit: 'cover',
                    width: 1,
                }}
            />
            <Typography sx={{ alignItems: 'start', color: 'white', display: 'flex', gap: 1, mt: 1, }} variant="body1">
                <MusicNote sx={{ color: 'white' }} />
                {coverage.Title}
            </Typography>
        </StackImage>
    );

    return (
        <Stack className="SectionActivities" spacing={2} sx={{ m: 5 }}>
            <ContentTitle text={Text.MusicalWork.Activities[context.language]} />
            <Grid container spacing={2} sx={{ mb: 2 }}>
                {
                    coverages.map((coverage, i) => (
                        <Grid key={i} size={{ xs: 6, md: 4 }}>
                            <RenderStackImage coverage={coverage} />
                        </Grid>
                    ))
                }
            </Grid>
            <Dialog open={openDialog} onClose={handleDialogClose} maxWidth="lg" fullWidth>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {coverages.find(c => c.ID === selectedId)?.Title}
                    <IconButton onClick={handleDialogClose} size="small">
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box component="iframe" src={`/MusicalWorkActivitiesContent?ID=${selectedId}`} sx={{ width: '100%', height: '600px', border: 'none', mt: 2 }} />
                </DialogContent>
            </Dialog>
        </Stack>
    );
};

export default React.memo(Activities);